import React from 'react';
import PropTypes from 'prop-types';

const ActionButton = ({
    buttonText,
    className,
    disabled,
    imgSource,
    onClick,
    ...props
}) => {
    const keyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onClick();
        }
    }

    return (
        <div {...props}
            className={`action-button ${className || ''}`}
            disabled={disabled}
            onClick={disabled ? null : onClick}
            tabIndex="0"
            onKeyDown={keyDown}
        >
            <img src={imgSource} alt={buttonText} />
            {buttonText && <span>{buttonText}</span>}
        </div>
    );
}

ActionButton.propTypes = {
    onClick: PropTypes.func
};

ActionButton.defaultProps = {
    buttonText: ''
};

export default ActionButton;
